module.exports = "./static/icon_empty.60ef04d4.png";